import { useQuery } from "@tanstack/react-query";
import { PropertyDto } from "@cma/shared/apis/comps/cma/generated";
import {
  convertFiltersSchemeToSidekickFindListingsV3,
  isModelEnoughToSearch,
  normalizeModel,
} from "../../chat-widgets/find-listings-search/helpers/search-comparable-form-model";
import { getWidgetActionsApiClient } from "@shared/apis/sidekick/api-factories";
import { FindListingsAv8Response } from "@shared/apis/sidekick/generated";
import { FindListingsSchema } from "../../chat-widgets/find-listings-search/helpers/property-search-filters-form-helpers";
import { extractQueryState } from "../helpers/extract-query-state";

const WIDGETS_FIND_LISTINGS_QUERY_KEY = "widgets-find-listings";
const CACHE_TIME_IN_MS = 1000 * 60 * 5; // 5 minutes

export const buildWidgetsFindListingsQueryKey = (
  state: FindListingsSchema | null,
) => {
  return [WIDGETS_FIND_LISTINGS_QUERY_KEY, normalizeModel(state || {})];
};

export function useWidgetsFindListings(props: {
  filters: FindListingsSchema | null;
  subjectProperty?: PropertyDto;
  onSuccess?: (data: FindListingsAv8Response) => void;
}) {
  const { filters, subjectProperty, onSuccess } = props;
  const api = getWidgetActionsApiClient();

  const query = useQuery({
    queryKey: buildWidgetsFindListingsQueryKey(filters),
    queryFn: async () => {
      if (!filters) return;
      const response = await api.widgetsControllersSidekickFindListingsV3({
        findListingsAv8Request: convertFiltersSchemeToSidekickFindListingsV3(
          filters,
          subjectProperty,
        ),
      });
      onSuccess?.(response);
      return response;
    },
    enabled: !!filters && isModelEnoughToSearch(filters),
    refetchOnWindowFocus: false,
    retry: (failureCount, error) => {
      const status = (error as any)?.response?.status || 0;
      if (failureCount < 3 && status === 429) {
        return true;
      }
      return false;
    },
    gcTime: CACHE_TIME_IN_MS,
    staleTime: CACHE_TIME_IN_MS,
  });

  return extractQueryState(query);
}
